import { InitialQueryPayment } from 'components/features/Configuration/types';

export const validatePaymentAmount = (payments: InitialQueryPayment[] | undefined, minValue: number): boolean => {
	return (payments || []).every((payment) => payment.amount >= minValue);
};
